import { Component, Input } from "@angular/core";

@Component({
  standalone: false,
    selector: 'mm-condensed-label-top-section',
    templateUrl: './condensed-label-top-section.component.html',
    styleUrls: ['./condensed-label-top-section.component.scss']
})

export class CondensedLabelTopSectionComponent {
    @Input() title: string;
    @Input() data: string;
    @Input() multilineData: string[];
    @Input() bottomBorder: boolean = true;

    constructor() {}
}